/** Freundliche deutsche Bezeichnungen für die Inhaltsfelder im Editor. */
export const SECTION_LABELS: Record<string, string> = {
  hero: 'Startbereich',
  about: 'Über den Workshop',
  features: 'Was dich erwartet',
  target: 'Für wen?',
  details: 'Details (Wann / Wo / Mit wem)',
  cta: 'Anmeldebereich',
  footer: 'Fußzeile',
};

const FIELD_LABELS: Record<string, string> = {
  title: 'Überschrift',
  title_line1: 'Titelzeile 1',
  title_line2: 'Titelzeile 2',
  title_line3: 'Titelzeile 3',
  title_italic: 'Titel (kursiv hervorgehoben)',
  subtitle: 'Untertitel',
  label: 'Kleine Beschriftung',
  badge: 'Auszeichnung / Banner',
  description: 'Beschreibung',
  text: 'Text',
  bottom_text: 'Abschlusstext',
  card1_title: 'Karte 1 – Überschrift',
  card1_text: 'Karte 1 – Text',
  card1_quote: 'Karte 1 – Zitat',
  card2_title: 'Karte 2 – Überschrift',
  card2_text: 'Karte 2 – Text',
  card2_quote: 'Karte 2 – Zitat',
  btn_primary: 'Button 1 – Text',
  btn_secondary: 'Button 2 – Text',
  btn_text: 'Button-Text',
  image: 'Bild',
  items: 'Karten',
  cards: 'Karten',
  wann_title: 'Wann – Überschrift',
  wann_text: 'Wann – Beschreibung',
  wann_info: 'Wann – Info-Label',
  wo_title: 'Wo – Überschrift',
  wo_text: 'Wo – Beschreibung',
  wo_info: 'Wo – Info-Label',
  mitwem_title: 'Mit wem – Name',
  mitwem_text: 'Mit wem – Beschreibung',
  mitwem_info: 'Mit wem – Rolle',
  image_title_line1: 'Bild-Titel Zeile 1',
  image_title_line2: 'Bild-Titel Zeile 2',
  image_label: 'Bild-Beschriftung',
  form_title: 'Formular-Überschrift',
  form_description: 'Formular-Beschreibung',
  form_note: 'Hinweistext unter Button',
  brand: 'Markenname',
  email: 'E-Mail-Adresse',
  phone: 'Telefonnummer',
  location: 'Standort / Ort',
  instagram_url: 'Instagram-Link',
  facebook_url: 'Facebook-Link',
  linkedin_url: 'LinkedIn-Link',
  impressum_url: 'Impressum-Link',
  datenschutz_url: 'Datenschutz-Link',
};

export function labelFor(key: string): string {
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];
  if (SECTION_LABELS[key]) return SECTION_LABELS[key];
  return key.charAt(0).toUpperCase() + key.slice(1);
}
